export const urls = {
	login: '/api/login',
	logout: '/api/logout',
	getMe: '/api/me',
	getCSRFToken: '/sanctum/csrf-cookie'
}
